import { Distance, Draggable } from '../../../../../FrontendBundle/Resources/js/ofcs';

/**
 * Event handler for draggable items on the canvas. The main task of this
 * object is the delegation of drag and drop events for a given element.
 *
 *     var dragAndDrop = new CanvasDraggable(canvas, element);
 *
 *     dragAndDrop.on('dragStart', function(e) {
 *         // ...
 *     });
 *     dragAndDrop.on('drag', function(e) {
 *         // ...
 *     });
 *     dragAndDrop.on('dragStop', function(e) {
 *         // ...
 *     });
 */
export default class CanvasDraggable extends Draggable {
    /**
     * Triggered while dragging
     *
     * @event drag
     * @param {Object} event Event object for the drag event
     * @param {jQuery.Event} event.originalEvent jQuery event from the DOM listeners
     * @param {number} event.pageX Position of mouse on pages x-axis
     * @param {number} event.pageY Position of mouse on pages y-axis
     * @param {number} event.offsetX Moved offset on the x-axis in pixel
     * @param {number} event.offsetY Moved offset on the y-axis in pixel
     * @param {Point} event.point Current point on the canvas
     * @param {Point} event.startPoint Starting Point on the canvas
     * @param {Distance} event.distance Distance between Current and Starting Point on the canvas
     * @param {string} event.type Key of triggered event
     * @param {HTMLElement|SVGElement} event.target
     */

    /**
     * Connected canvas object
     *
     * @protected
     * @property {Ofcs.Editor.Canvas} canvas
     */

    /**
     * Creates a new drag-and-drop handler for the given element
     *
     * @constructor
     * @param {Ofcs.Editor.Canvas} canvas Canvas which contains the element
     * @param {HTMLElement|SVGElement|jQuery} element Element to bind the dragstart on
     * @param {string} selector A selector string to filter the descendants of the selected elements
     *                          that trigger the event. If the selector is null or omitted, the event
     *                          is always triggered when it reaches the selected element.
     */
    constructor(canvas, ...args) {
        super(...args);
        this.canvas = canvas;
    }

    /**
     * @protected
     * @param {string} type The triggered which will be triggered
     * @param {Object} events Object with startEvent and moveEvent
     * @return {jQuery.Event}
     */
    createEvent(type, events) {
        const point = this.canvas.getPointByPixels(events.moveEvent.pageX, events.moveEvent.pageY);
        const startPoint = this.canvas.getPointByPixels(events.startEvent.pageX, events.startEvent.pageY);

        const event = super.createEvent(type, events);

        event.point = point;
        event.startPoint = startPoint;
        event.distance = new Distance(startPoint, point);

        return event;
    }
}
